// extracted by mini-css-extract-plugin
export default {"wrapper":"TimerComponent_wrapper__4Cc5s","text_round_close":"TimerComponent_text_round_close__V5xcU","timer":"TimerComponent_timer__LJ-wt"};